import { IDictionary } from '@bimser/core';
import { CustomizedDxColumn } from '..';

export function calculateCellValue(this: CustomizedDxColumn, row: IDictionary<any>) {
	return row[this.dataField]?.value;
}
